import { GetResponse, GetResponseData } from '@customTypes/api/Notification';
import { Endpoints, ServiceAPI } from '@service/index';

import { useQuery } from '../helper/useQuery';

const useGetNotification = () => {
  return useQuery<GetResponseData>(
    [],
    () =>
      ServiceAPI.get<null, GetResponse>(Endpoints.Notification()).then(
        response => response.data.data,
      ),
    {
      staleTime: 60 * 1000,
      cacheTime: 60 * 1000,
    },
  );
};

export default useGetNotification;
